import { render, staticRenderFns } from "./EleFormCheckboxButton.vue?vue&type=template&id=01004056&"
import script from "./EleFormCheckboxButton.vue?vue&type=script&lang=js&"
export * from "./EleFormCheckboxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports